export enum PopularTagsActionTypes {
  GET_POPULAR_TAGS_REQUEST = '[PopularTags] GET_POPULAR_TAGS_REQUEST',
  GET_POPULAR_TAGS_SUCCESS = '[PopularTags] GET_POPULAR_TAGS_SUCCESS',
  GET_POPULAR_TAGS_ERROR = '[PopularTags] GET_POPULAR_TAGS_ERROR',
}
